import React, { useState } from "react";
import { notification } from "antd";
import { client } from "../libs/client";

const AccountDeletionScheduledBanner = ({
  deletionScheduledFor,
  onCancelSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelDeletion = async () => {
    setIsLoading(true);
    try {
      await client.post("/user/cancel-account-deletion");
      notification.success({
        message: "Deletion cancelled",
        description: "Your account deletion has been cancelled successfully.",
      });
      if (onCancelSuccess) {
        onCancelSuccess();
      }
    } catch (error) {
      notification.error({
        message: "Failed to cancel deletion",
        description:
          error?.response?.data?.message || "Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="w-full bg-red-50 border-b-2 border-red-300 px-5 md:px-10 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <svg
            className="w-5 h-5 text-red-600 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          <div>
            <p className="text-sm font-medium text-red-800">
              Account scheduled for deletion
            </p>
            <p className="text-xs text-red-700">
              Your account is scheduled to be permanently deleted on{" "}
              {formatDate(deletionScheduledFor)}. Click the button below to
              cancel this action.
            </p>
          </div>
        </div>
        <button
          onClick={handleCancelDeletion}
          disabled={isLoading}
          className="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white text-sm font-medium rounded transition-colors whitespace-nowrap"
        >
          {isLoading ? "Cancelling..." : "Cancel Deletion"}
        </button>
      </div>
    </div>
  );
};

export default AccountDeletionScheduledBanner;
